import { Badge } from '@kalos/ui';
import type { FC } from 'react';

import { type DerivedStatus, STATUS_LABELS } from '../types';

export const StatusBadge: FC<{ status: DerivedStatus; className?: string }> = ({
  status,
  className,
}) => {
  const cls = `whitespace-nowrap ${className ?? ''}`;
  switch (status) {
    case 'active':
      return (
        <Badge variant="success" className={cls}>
          {STATUS_LABELS.active}
        </Badge>
      );
    case 'admin_review':
      return (
        <Badge
          className={`border-transparent bg-blue-500 text-white shadow hover:bg-blue-500/80 ${cls}`}
        >
          {STATUS_LABELS.admin_review}
        </Badge>
      );
    case 'awaiting_confirmation':
      return (
        <Badge
          className={`border-transparent bg-purple-500 text-white shadow hover:bg-purple-500/80 ${cls}`}
        >
          {STATUS_LABELS.awaiting_confirmation}
        </Badge>
      );
    case 'not_active_yet':
      return (
        <Badge variant="outline" className={`border-sky-400 text-sky-600 ${cls}`}>
          {STATUS_LABELS.not_active_yet}
        </Badge>
      );
    case 'pending_payment':
      return (
        <Badge variant="warning" className={cls}>
          {STATUS_LABELS.pending_payment}
        </Badge>
      );
    case 'scheduled_cancel':
      return (
        <Badge variant="secondary" className={cls}>
          {STATUS_LABELS.scheduled_cancel}
        </Badge>
      );
    case 'cancelled':
      return (
        <Badge variant="secondary" className={cls}>
          {STATUS_LABELS.cancelled}
        </Badge>
      );
    // Outline slate, not the grey Cancelled fill — a superseded term ended on good terms.
    case 'renewed':
      return (
        <Badge variant="outline" className={`border-slate-400 text-slate-500 ${cls}`}>
          {STATUS_LABELS.renewed}
        </Badge>
      );
    case 'expired':
      return (
        <Badge variant="outline" className={`border-gray-400 text-gray-500 ${cls}`}>
          {STATUS_LABELS.expired}
        </Badge>
      );
    case 'unknown':
      return (
        <Badge variant="outline" className={cls}>
          {STATUS_LABELS.unknown}
        </Badge>
      );
    default: {
      const _exhaustive: never = status;
      return _exhaustive;
    }
  }
};
